import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { SV_URL } from '../../../@core/utils/utils';


@Injectable({ providedIn: 'root' })
export class EnvioProvider {

  public id: string;
  constructor(public http: HttpClient) {
  }

  saveEnvio(data, cli, valor, cod, user, alt) {
    const url: string = SV_URL + '/postEnvio';

    const postParams = {
      data: data,
      cli: cli ,
      valor: valor,
      cod: cod,
      user: user,
      alt: alt,
    };

    this.http.post(url, postParams)
    .subscribe(res => {
      console.log('Enviado Com Sucesso');
      }, error => {
      console.log(error);
    });
  }

  putEnvio(id, data, cli, valor, cod, user, alt) {
    const url: string = SV_URL + '/putEnvio';

    const postParams = {
      id: id,
      data: data,
      cli: cli ,
      valor: valor,
      cod: cod,
      user: user,
      alt: alt,
    };

    this.http.put(url, postParams)
    .subscribe(res => {
      console.log('Enviado Com Sucesso');
      }, error => {
      console.log(error);
    });
  }

  putEnvioStatus(id, cupom, status) {
    return new Promise<void>(resolve => {
      const url: string = SV_URL + '/putEnvioStatus';

      const postParams = {
        id: id,
        cupom: cupom,
        status: status,
      };

      this.http.put(url, postParams)
      .subscribe(res => {
        console.log('Enviado Com Sucesso');
        resolve();
        }, error => {
        console.log(error);
        resolve();
      });
    });

  }

  putEnvioAutorizado(id, user, data, status) {
    const url: string = SV_URL + '/putEnvioAutorizado';

    const postParams = {
      id: id,
      user: user,
      data: data,
      status: status,
    };

    this.http.put(url, postParams)
    .subscribe(res => {
      console.log('Enviado Com Sucesso');
      }, error => {
      console.log(error);
    });
  }


}

